import dayjs from "dayjs";

import { type PeriodKeys } from "@/pages/OpenBriefPage/OpenBriefListHeader/_partials/PeriodSelector";

export const getStartDate = (period: PeriodKeys = "6_months_ago") => {
  const now = new Date();
  switch (period) {
    case "1_month_ago":
      return dayjs(now).subtract(1, "months");
    case "3_months_ago":
      return dayjs(now).subtract(3, "months");
    case "6_months_ago":
      return dayjs(now).subtract(6, "months");
    case "1_year_ago":
      return dayjs(now).subtract(1, "years");
  }
};
